import { getComponentFromName } from '@folklore/utils';
import { ComponentType } from 'react';

import * as Components from './components';

interface MesQuebecAnimationProps {
    kind?: string | null;
    [key: string]: unknown;
}

function MesQuebecAnimation({ kind = null, ...otherProps }: MesQuebecAnimationProps) {
    const Component = getComponentFromName(Components, kind, null) as ComponentType<any> | null;
    return Component !== null ? <Component {...otherProps} /> : null;
}

export default MesQuebecAnimation;
